import ReactDOM from "react-dom/client";
import App from "./App";

import 'react-loading-skeleton/dist/skeleton.css'
import 'aos/dist/aos.css'
import "./index.scss";
import "../src/tailwind/output.css"
import "./App.scss";

import "bootstrap/dist/css/bootstrap.rtl.min.css";
import "bootstrap/dist/js/bootstrap";
import "material-symbols";

import "./assets/fonts/IRANSansWeb/eot/IRANSansWeb(FaNum).eot";
import "./assets/fonts/IRANSansWeb/eot/IRANSansWeb(FaNum)_Black.eot";
import "./assets/fonts/IRANSansWeb/eot/IRANSansWeb(FaNum)_Bold.eot";
import "./assets/fonts/IRANSansWeb/eot/IRANSansWeb(FaNum)_Light.eot";
import "./assets/fonts/IRANSansWeb/eot/IRANSansWeb(FaNum)_Medium.eot";
import "./assets/fonts/IRANSansWeb/eot/IRANSansWeb(FaNum)_UltraLight.eot";

import "./assets/fonts/IRANSansWeb/ttf/IRANSansWeb(FaNum).ttf";
import "./assets/fonts/IRANSansWeb/ttf/IRANSansWeb(FaNum)_Black.ttf";
import "./assets/fonts/IRANSansWeb/ttf/IRANSansWeb(FaNum)_Bold.ttf";
import "./assets/fonts/IRANSansWeb/ttf/IRANSansWeb(FaNum)_Light.ttf";
import "./assets/fonts/IRANSansWeb/ttf/IRANSansWeb(FaNum)_Medium.ttf";
import "./assets/fonts/IRANSansWeb/ttf/IRANSansWeb(FaNum)_UltraLight.ttf";

import "./assets/fonts/IRANSansWeb/woff/IRANSansWeb(FaNum).woff";
import "./assets/fonts/IRANSansWeb/woff/IRANSansWeb(FaNum)_Black.woff";
import "./assets/fonts/IRANSansWeb/woff/IRANSansWeb(FaNum)_Bold.woff";
import "./assets/fonts/IRANSansWeb/woff/IRANSansWeb(FaNum)_Light.woff";
import "./assets/fonts/IRANSansWeb/woff/IRANSansWeb(FaNum)_Medium.woff";
import "./assets/fonts/IRANSansWeb/woff/IRANSansWeb(FaNum)_UltraLight.woff";

import "./assets/fonts/IRANSansWeb/woff2/IRANSansWeb(FaNum).woff2";
import "./assets/fonts/IRANSansWeb/woff2/IRANSansWeb(FaNum)_Black.woff2";
import "./assets/fonts/IRANSansWeb/woff2/IRANSansWeb(FaNum)_Bold.woff2";
import "./assets/fonts/IRANSansWeb/woff2/IRANSansWeb(FaNum)_Light.woff2";
import "./assets/fonts/IRANSansWeb/woff2/IRANSansWeb(FaNum)_Medium.woff2";
import "./assets/fonts/IRANSansWeb/woff2/IRANSansWeb(FaNum)_UltraLight.woff2";
import { Provider } from "react-redux";
import store from "./store";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <App dir="rtl" />
  </Provider>
);

document.getElementsByTagName("html")[0].setAttribute("dir", "rtl");
document.getElementsByTagName("html")[0].setAttribute("lang", "fa-IR");
